import axios from 'axios'

export const getBackendBaseUrl = (): string => {
  const currentFrontendUrl = window.location.href

  if (currentFrontendUrl.includes('localhost') || currentFrontendUrl.includes('127.0.0.1')) {
    return process.env.REACT_APP_BACKEND_URL || 'http://localhost:3007'
  }

  if (currentFrontendUrl.includes('.netlify.app')) {
    return 'https://petso-backend.herokuapp.com'
  }

  return 'https://petso-backend.herokuapp.com'
}

export const backendClient = axios.create({
  baseURL: `${getBackendBaseUrl()}/v1`,
})
